import { useHTTP, useHTTPQueryWithCursor } from "@/lib/http";

export interface SearchProductsResponseModel {
	readonly productId: string;
	readonly name: string;
	readonly imageUrl: string;
	readonly number: string | null;
}

export const useProductsSearch = (searchQuery: string) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor<SearchProductsResponseModel>({
		queryKey: ["productSearch", searchQuery],
		queryFn: ({ pageParam = 0 }) => {
			return http({
				method: "GET",
				url: `/product/search?q=${searchQuery}&cursor=${pageParam}`
			});
		},
		retry: false
	});
};
